import { Link } from 'react-router-dom';
import styles from './Login.module.css';
import LoginModal from './LoginModal';

export default function Login(): JSX.Element {
  return (
    <div className={styles.container}>
      <Link to="/" className={styles.splashBackground} />
      <LoginModal />
    </div>
  );
} 